import { Provider } from '@angular/core';
import {
  contextSettings,
  MainMenuItem,
} from '@nx-icilalune/data/icilalune/types';
import {
  COLOR_THEME,
  CURRENT_MAIN_MENU_ITEM,
} from '@nx-icilalune/data/icilalune/tokens';
import { map, Observable } from 'rxjs';

export const THEME_PROVIDERS: Provider[] = [
  {
    provide: COLOR_THEME,
    deps: [CURRENT_MAIN_MENU_ITEM],
    useFactory: (
      currentMainMenuItem$: Observable<MainMenuItem | undefined>
    ) => {
      return currentMainMenuItem$.pipe(
        map((currentMainMenuItem) => {
          if (currentMainMenuItem?.color) {
            return currentMainMenuItem.color;
          }
          return contextSettings;
        })
      );
    },
  },
];
